import { FC, memo } from "react";
import { InputStyled } from "./styled";
import { InputProps } from "./types";
import { WarningSvg } from "../../../assets/warningSvg";
import { UnusedSvg } from "../../../assets/unusedSvg";

const Input: FC<InputProps> = ({
  id,
  label,
  maxLength,
  minLength,
  value,
  color,
  fontSize,
  fontWeight,
  ...restProps
}) => {
  const showMaxLengthTip = !minLength && maxLength;
  return (
    <InputStyled
      spanError={maxLength !== value?.length}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
    >
      {label && <label htmlFor={id}>{label}</label>}
      <input
        id={id}
        maxLength={maxLength}
        minLength={minLength}
        value={value}
        {...restProps}
      />
      {showMaxLengthTip &&
        (value ? (
          value.length === maxLength ? (
            <UnusedSvg color="#027A48" />
          ) : (
            <WarningSvg />
          )
        ) : (
          <UnusedSvg />
        ))}
    </InputStyled>
  );
};

export default memo(Input);
